export default '/static/frontend/ReachDigital/12gobiking/dist/assets/klarna-pay-now-f319324c.png'